export class datosLayers {
    constructor(
        public id: string,
        public nombre: string,
        public datos: any,
        public campos: any[],
        public url?: string,
        public filtro?: string,
    ){}
}